import React, { ReactElement } from "react";
import HubOrderDetails from "../../../components/Hubs/Orders/details";
import Layout from "../../../components/layout";

const HubOrderDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <HubOrderDetails />
    </Layout>
  );
};

export default HubOrderDetailsPage;
